import { z } from 'zod';
import { FrontColor } from '../../../models/environment';

export const schema = z.object({
  version: z.enum([FrontColor.Blue, FrontColor.Green]),
});

export type Schema = z.infer<typeof schema>;
